import React from "react";
import { useSelector } from "react-redux";

import moment from "moment";

const CommunityEachListType = ({ item }) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);

	if (reduxChannel?.user_id) {
		return (
			<>
				<div className={`community-each-component-title-div`}>
					<img
						src={`${process.env.REACT_APP_S3_HOST}/image/together/profile_${reduxChannel?.user_id}.${reduxChannel?.profile_img_type}`}
						// src={`/assets/images/channel/doctor.png`}
						onError={({ currentTarget }) => {
							currentTarget.onerror = null; // prevents looping
							// currentTarget.style.display = "none";
							currentTarget.src = `/assets/images/channel/basic.png`;
						}}
						alt={`채널 이미지`}
						className={`community-each-component-title-image`}
					/>
					<div className={`community-each-component-nickname-time-div`}>
						<div className={`nickname-div`}>
							<p className={`nickname`}>{reduxChannel?.nickname}</p>
							<p
								className={`gray category`}
								style={{ backgroundColor: `${item?.background_color}` }}
							>
								{item?.category_name}
							</p>
						</div>
						<p className={`gray`}>
							{moment(item?.created_at).format("M월 D일")}
						</p>
					</div>
				</div>

				<div className={`community-each-component-body-div`}>
					<p
						style={
							item?.communityImageList?.length
								? {}
								: {
										width: "100%",
								  }
						}
					>
						<b>{item?.title ? `${item?.title} ` : ""}</b>
						{item?.body}
					</p>

					{!!item?.communityImageList?.length && (
						<div className={`community-each-component-image-div`}>
							<img
								src={`${process.env.REACT_APP_S3_HOST}/image/together/community/${reduxChannel?.user_id}/${item?.communityImageList?.[0]?.title}.${item?.communityImageList?.[0]?.img_type}`}
								onError={({ currentTarget }) => {
									currentTarget.onerror = null; // prevents looping
									currentTarget.style.display = "none";
									// currentTarget.src = `/assets/images/no-product.png`;
								}}
								alt={`게시판 이미지`}
							/>
							{item?.communityImageList?.length > 1 && (
								<div className={`image-count`}>
									<p>{item?.communityImageList?.length}</p>
								</div>
							)}
						</div>
					)}
				</div>

				<div className={`community-each-component-footer-div`}>
					<p className={`gray`}>
						<img
							src={`/assets/images/channel/favorite-off.png`}
							alt={`커뮤니티 아이콘`}
						/>{" "}
						{item?.like_num}
					</p>
					<p className={`gray`}>
						<img
							src={`/assets/images/channel/comment.png`}
							alt={`커뮤니티 아이콘`}
						/>{" "}
						{item?.comment_num}
					</p>
					<p
						className={`gray`}
						style={{
							marginLeft: "auto",
						}}
					>
						<img
							src={`/assets/images/channel/views.png`}
							alt={`커뮤니티 아이콘`}
						/>
						{/*{item?.view_num}*/}
						{Math.ceil(item?.view_num * (5 + (item?.id % 10) / 10))}
					</p>
				</div>
			</>
		);
	} else {
		return <></>;
	}
};

export default CommunityEachListType;
